var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhoneFill = function SvgPhoneFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.05 7.99v1.59a.45.45 0 0 1-.419.45 8 8 0 0 1-.481.02 7.2 7.2 0 0 1-7.2-7.2q0-.187.02-.481a.45.45 0 0 1 .45-.419h1.59a.225.225 0 0 1 .224.203 6.3 6.3 0 0 0 .572 2.049.205.205 0 0 1-.066.255l-.97.694A5.87 5.87 0 0 0 6.85 8.23l.693-.97a.21.21 0 0 1 .258-.067 6.3 6.3 0 0 0 2.047.571.225.225 0 0 1 .202.224Z"
  })));
};
export default SvgPhoneFill;